<template>
  <v-app>

    <navbar></navbar>

    <v-content>
      <router-view />
      <generic-modal v-if="$route.name == 'invoice.preview' ||  $route.name == 'invoice.show' "></generic-modal>
         <v-snackbar v-model="$store.state.snack.show" :timeout="3000">
        {{ $store.state.snack.text }}
        <v-btn text @click="snack = false">{{$t('app.close')}}</v-btn>
      </v-snackbar>
    </v-content>
    <footer-bar></footer-bar>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";
import FooterBar from "./components/FooterBar";
import GenericModal from "./components/GenericModal";

export default {
  name: "App",

  components: { Navbar, FooterBar, GenericModal },
  methods: {},
  data: () => ({
    //
  })
};
</script>
